import FincTableSortAndOrder from './fincchta-table-sort-and-filter';
import FincTableSwitcher from './fincchta-table-switcher';

function addSortAndOrder() {
  const roots = document.querySelectorAll('.fincchta-table-wrapper');
  [...roots].forEach((root) => new FincTableSortAndOrder({
    rootEl: root,
  }));
}

function addTableSwitcher() {
  const roots = document.querySelectorAll('.section--fincchta-table');
  [...roots].forEach((root) => new FincTableSwitcher({
    rootEl: root,
  }));
}

export default function init() {
  addTableSwitcher();
  addSortAndOrder();
}
